import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReferencesComponent } from './components/references/references.component';
import { SharedModule } from '../shared/shared.module';
import { ConstructionMaintenanceComponent } from './components/construction-maintenance/construction-maintenance.component';
import { ContractManagementComponent } from './components/contract-management/contract-management.component';
import { ReferenceRoutingModule } from './reference-routing.module';
import { DocumentGridDialogComponent } from './components/document-grid-dialog/document-grid-dialog.component';
import { MaterialModule } from '../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';
import { CustomerfocusRiskmanagementComponent } from './components/customerfocus-riskmanagement/customerfocus-riskmanagement.component';
import { HseMarketingDocumetsComponent } from './components/hse-marketing-documets/hse-marketing-documets.component';
import { InforDocumentsComponent } from './components/infor-documents/infor-documents.component';
import { QHSEComponent } from './components/qhse/qhse.component';
import { QHSEdocumentsPAHWS2Component } from './components/qhsedocuments-pahws2/qhsedocuments-pahws2.component';
import { ServicesPropertyMgmtComponent } from './components/services-property-mgmt/services-property-mgmt.component';
import { VendorContractSopComponent } from './components/vendor-contract-sop/vendor-contract-sop.component';
import { WorkforceplanningResourceProcessComponent } from './components/workforceplanning-resource-process/workforceplanning-resource-process.component';
import { AccreditationKuwaitComponent } from './components/accreditation-kuwait/accreditation-kuwait.component';
import { AccreditationUaeComponent } from './components/accreditation-uae/accreditation-uae.component';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ToastrModule } from 'ngx-toastr';
import { DocumentHistoryComponent } from './components/document-history/document-history.component';
import { EnvironmentalManagementComponent } from './components/environmental-management/environmental-management.component';
import { HealthSafetyComponent } from './components/health-safety/health-safety.component';
import { QualityManagementComponent } from './components/quality-management/quality-management.component';
import { MatIconModule } from '@angular/material/icon';
import { ReferenceCategoryComponent } from './components/reference-category/reference-category.component';
import { ReferenceDocumentInfoDialogComponent } from './components/reference-document-info-dialog/reference-document-info-dialog.component';

@NgModule({
  declarations: [
    AccreditationKuwaitComponent,
    AccreditationUaeComponent,
    ContractManagementComponent,
    ConstructionMaintenanceComponent,
    CustomerfocusRiskmanagementComponent,
    HseMarketingDocumetsComponent,
    InforDocumentsComponent,
    QHSEComponent,
    QHSEdocumentsPAHWS2Component,
    ServicesPropertyMgmtComponent,
    VendorContractSopComponent,
    WorkforceplanningResourceProcessComponent,
    ReferencesComponent,
    DocumentGridDialogComponent,
    DocumentHistoryComponent,
    QualityManagementComponent,
    HealthSafetyComponent,
    EnvironmentalManagementComponent,
    ReferenceCategoryComponent,
    ReferenceDocumentInfoDialogComponent
  ],
  imports: [
    CommonModule,
    ReferenceRoutingModule,
    SharedModule,
    MaterialModule,
    ReactiveFormsModule,
    TranslocoModule,
    RouterModule,
    FlexLayoutModule,
    ToastrModule,
    FormsModule,
    MatIconModule,
  ],
})
export class ReferencesModule { }
